<div class="d-flex align-items-center product-list-item">
  <ng-container *ngIf="orderLine.details.url then urlImg else otherImg"></ng-container>

  <div class="align-self-center flex-grow-1 me-3">
    <div>
      <div class="fw-bold product-item-font">
        {{ orderLine.name }}
      </div>

      <div class="mt-2 font-sm" *ngIf="orderLine.details.description">
        {{ orderLine.details.description }}
      </div>
    </div>

    <div>
      <div class="d-inline-block text-danger font-xs"
           (click)="onRemoveOrderLine.emit(orderLine)"
           [translate]="'cart.deleteCake'">
      </div>
    </div>
  </div>

  <div>
    <div class="text-center nowrap product-item-font mt-2">
      {{ (orderLine.price * orderLine.count) | currencyFormat: currency }}
    </div>
  </div>
</div>

<ng-template #urlImg>
  <div class="product-list-item-img me-3" *ngIf="orderLine.details.url">
    <img [src]="orderLine.details.url">
  </div>
</ng-template>

<ng-template #otherImg>
  <div class="product-list-item-img me-3" *ngIf="orderLine.details.picture">
    <img [src]="orderLine.details.picture | multiImage: 'smallUrl' : true : ''">
  </div>
</ng-template>
